import { mapState, mapActions, mapMutations, mapGetters } from 'vuex';

import dataLayersMixin from '@/utils/mixins/dataLayersMixin';
import { HealthInsuranceClientId } from '../enums/paymentMagicNumberEnum';

const unitArrivalMixin = {
  name: 'unitArrivalMixin',
  mixins: [dataLayersMixin],

  data() {
    return {
      openDrawer: false,
      notArrived: false,
    };
  },
  computed: {
    ...mapState({
      currentAdmissionPayment: ({ currentAdmission }) => currentAdmission.data.payments[0],
      currentAdmission: ({ currentAdmission }) => currentAdmission.data,
      restrictiveQuestions: ({ currentAdmission }) => currentAdmission.data.questions,
      isAdmissionAuthorized: ({ global }) => global.isAdmissionAuthorized,
      amilTokensToValidate: ({ global }) => global.amilTokensToValidate,
    }),

    ...mapGetters({
      isT2FlowAllowed: 'global/isT2FlowAllowed',
      isVaccineFlow: 'global/isVaccineFlow',
      isCollaboratorFlow: 'global/isCollaboratorFlow',
      isBradescoFlowSuccess: 'global/isBradescoFlowSuccess',
    }),

    unit() {
      return this.selectedUnit || {};
    },

    hasMealQuestionsAnswared() {
      return this.restrictiveQuestions?.some((element) => element.question === 'last_meal_instant');
    },
  },

  methods: {
    ...mapMutations({
      setModalDisplayFlag: 'SET_MODAL_DISPLAY',
      setAtUnit: 'global/SET_AT_UNIT',
    }),
    ...mapActions(['getAdmissionById', 'global/updateFlowSteps', 'getAmilTokenValidation']),

    async confirmedArrivalFlow() {
      this.setAtUnit(true);
      this['global/updateFlowSteps']([10, 2]);

      const paymentStatus = this.currentAdmission.payments[0]?.status;

      if (paymentStatus === 'PAID') {
        this['global/updateFlowSteps']([8, 2]);
      }

      if (this.isT2FlowAllowed || this.isVaccineFlow || this.isCollaboratorFlow) {
        await this.getAdmissionById();
      }
      this.toggleConfirmArrivingModalDisplay(false);

      if (this.isAdmissionAuthorized || this.isT2FlowAllowed) {
        if (
          this.currentAdmissionPayment.clientId === HealthInsuranceClientId.AMIL ||
          this.currentAdmissionPayment.clientId === HealthInsuranceClientId.DASAFUNC
        ) {
          const areAllTokensValidated = await this.getAmilTokenValidation();
          if (!areAllTokensValidated) {
            return this.goNextStep('authorization_token_amil', { unitArrival: true });
          }
        }

        if (!this.hasMealQuestionsAnswared) {
          return this.goNextStep('questions_conclusion_step', { unitArrival: true });
        }

        if (
          this.currentAdmissionPayment.clientId === HealthInsuranceClientId.BRADESCO &&
          !this.isBradescoFlowSuccess
        ) {
          return this.goNextStep('unscheduled_exams_step', { unitArrival: true });
        }

        return this.goNextStep('admission_done', { unitArrival: true });
      }
      return this.goNextStep('queue_end_flow', { unitArrival: true });
    },

    toggleConfirmArrivingModalDisplay(isOpen, notArrived) {
      this.openDrawer = isOpen;
      this.notArrived = notArrived;
    },

    notArrivalYet() {
      this.mostCommonPagesAnalytics({
        eventType: 'submit',
        step: 'confirmação_chegada_unidade',
        screen: 'confirmação_chegada_unidade',
        complementaryObject: {
          presence_confirmation: {
            status: 'não_chegou',
          },
        },
      });

      this.openDrawer = false;
    },
  },
};

export default unitArrivalMixin;
